<div class="relative inline-flex items-center pr-5 uppercase">
  {{ item().label }}

  <div class="absolute -top-2 -right-1">
    <app-counter-badge [counter$]="item().counter$" />
  </div>
</div>
